<header class="seamless-header">
    <!-- Fixed navbar -->
    <nav class="p-3 px-md-0 px-3">
        <div class="container d-flex flex-row justify-content-between align-items-center">
            <a name="btn_JustmoneyLogo_Register" class="logo-hld navbar-brand p-0" href="https://www.justmoney.co.za/"
                target="_blank">
                <img src="../../assets/images/logoJM.png" alt="" class="jm-logo" />
            </a>
            <a id="btn_userJourney_logOut_registration" class="logout-btn" href="javascript:void(0)" (click)="logout()" 
                name="btn_userJourney_logOut_registration">Log Out
            </a>
        </div>
    </nav>
</header>